module.exports = __webpack_public_path__ + "static/img/theme4.1f98588d.png";